import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as sw from './registerServiceWorker';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'


ReactDOM.render(<App />, document.getElementById('root'));
sw.unregister()
